import React from "react";
import Accordion from "../../accordion";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/jetlift/collapse/collapse.facade";

interface ProjectSummaryProps {
    data?: { label: string; value: string | number; unit?: string, isSuccess?: boolean, isWarning?: boolean }[];
    title: string;
};

const ProjectSummary: React.FC<ProjectSummaryProps> = ({ data, title }) => {
    const { projectSummaryCollapse } = useAppSelector((state) => state?.jetlift?.collapse);
    const { updateProjectSummaryCollapse } = useCollapseFacade();
    return (
        <>
            <Accordion
                title={title}
                isOpen={projectSummaryCollapse}
                onToggle={() => updateProjectSummaryCollapse(!projectSummaryCollapse)}
                content={
                    (
                        <div className="grid grid-cols-6 gap-[8px] py-4 px-6 w-full bg-darkcolor-600 bg-opacity-50 rounded-b-[8px]">
                            {data && data?.length > 0 && data?.map((item, index) => (
                                <div className="flex flex-col" key={index}>
                                    <span className="text-neutral-25 text-[14px] font-normal">{item?.label}</span>
                                    <span className={`${item?.isSuccess ? "text-[14px] border-success-400 border-[1px] px-[10px] py-[2px] rounded-[4px] text-success-400 w-3/4" : item?.isWarning ? "text-[14px] border-warning-400 border-[1px] px-[10px] py-[2px] rounded-[4px] text-warning-400 w-3/4" : "text-[18px] text-neutral-25"} font-semibold`}>{item?.value} {item?.unit}</span>
                                </div>
                            ))}
                        </div>
                    )
                }
            />
        </>
    );
};

export default ProjectSummary;
